export default __webpack_public_path__ + "static/media/barcode.8c3176da.svg";